(() => {
  const guides = new WeakMap();
  const entryPlacements = new Map();
  function placeEntry(entry) {
    const sectionId = entry.dataset.sectionId;
    const section = document.getElementById(`MainProduct-${sectionId}`);
    if (!section) return;
    const previous = entryPlacements.get(sectionId);
    if (previous?.section === section && previous.entry === entry) {
      previous.place();
      return;
    }
    previous?.disconnect();
    const marker = document.createComment('Size guide original position');
    entry.before(marker);
    let heading;
    let label;

    function place() {
      const globoLabel = section.querySelector('.globo-swatch-product-detail .globo-swatch-list > .swatch--gl[data-option-index][data-display-style="4"] > .name-option[data-name="Size" i]');
      let nextLabel = globoLabel?.nextElementSibling?.matches('.dropdown-selector') ? globoLabel : null;
      if (!nextLabel) {
        const nativeSize = section.querySelector('.canvoil-options select[name="options[Size]" i]');
        const group = nativeSize?.closest('[data-option-group]');
        nextLabel = group?.querySelector(':scope > .canvoil-options__label') || null;
      }
      const nextHeading = nextLabel?.parentElement || null;
      if (heading !== nextHeading) heading?.classList.remove('canvoil-size-guide-option-heading');
      if (label !== nextLabel) label?.classList.remove('canvoil-size-guide-option-label');
      heading = nextHeading;
      label = nextLabel;
      if (!label || !heading) {
        if (marker.isConnected && marker.nextSibling !== entry) marker.after(entry);
        return;
      }
      heading.classList.add('canvoil-size-guide-option-heading');
      label.classList.add('canvoil-size-guide-option-label');
      // Keep the Size label immediately followed by its dropdown for Glo and custom quotes.
      if (entry.parentElement !== heading || entry.nextElementSibling !== label) label.before(entry);
    }

    place();
    const observer = new MutationObserver(records => {
      if (!section.isConnected) { disconnect(); return; }
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1))) place();
    });
    observer.observe(section, {childList: true, subtree: true});
    function disconnect() {
      observer.disconnect();
      marker.remove();
      if (entryPlacements.get(sectionId)?.entry === entry) entryPlacements.delete(sectionId);
    }
    entryPlacements.set(sectionId, {section, entry, place, disconnect});
  }

  function setup(modal) {
    if (guides.has(modal)) return;
    const tabs = [...modal.querySelectorAll('[data-size-guide-tab]')];
    const panels = [...modal.querySelectorAll('[data-size-guide-panel]')];
    const body = modal.querySelector('.canvoil-size-guide__body');
    let activePanel;

    function loadActiveImages() {
      if (!modal.hasAttribute('open') || !activePanel) return;
      activePanel.querySelectorAll('img[data-size-guide-image][data-src]').forEach(image => {
        const source = image.getAttribute('data-src');
        if (!source) return;
        image.setAttribute('loading', 'lazy');
        image.setAttribute('src', source);
        image.removeAttribute('data-src');
      });
    }

    function selectTab(tab, focus) {
      const controlled = panels.find(panel => panel.id === tab.getAttribute('aria-controls'));
      if (!controlled) return;
      const changed = activePanel && activePanel !== controlled;
      tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel !== controlled; });
      activePanel = controlled;
      if (changed && body) body.scrollTop = 0;
      loadActiveImages();
      if (focus) tab.focus();
    }

    function onClick(event) {
      const tab = event.target.closest('[data-size-guide-tab]');
      if (tabs.includes(tab)) selectTab(tab, false);
    }

    function onKeydown(event) {
      const index = tabs.indexOf(event.target.closest('[data-size-guide-tab]'));
      if (index < 0 || event.altKey || event.ctrlKey || event.metaKey) return;
      const vertical = tabs[index].closest('[role="tablist"]')?.getAttribute('aria-orientation') === 'vertical';
      let target;
      if (event.key === (vertical ? 'ArrowDown' : 'ArrowRight')) target = (index + 1) % tabs.length;
      else if (event.key === (vertical ? 'ArrowUp' : 'ArrowLeft')) target = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = tabs.length - 1;
      else return;
      event.preventDefault();
      selectTab(tabs[target], true);
    }

    modal.addEventListener('click', onClick);
    modal.addEventListener('keydown', onKeydown);
    const observer = new MutationObserver(loadActiveImages);
    observer.observe(modal, {attributes: true, attributeFilter: ['open']});
    guides.set(modal, {
      disconnect() {
        observer.disconnect();
        modal.removeEventListener('click', onClick);
        modal.removeEventListener('keydown', onKeydown);
        modal.removeAttribute('data-size-guide-ready');
        guides.delete(modal);
      }
    });
    const initial = tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    if (initial) selectTab(initial, false);
    modal.dataset.sizeGuideReady = 'true';
  }

  function initialize() {
    document.querySelectorAll('modal-dialog.canvoil-size-guide').forEach(setup);
    document.querySelectorAll('[data-size-guide-entry][data-section-id]').forEach(placeEntry);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    const sectionIds = new Set(event.detail?.sectionId ? [event.detail.sectionId] : []);
    entryPlacements.forEach((placement, sectionId) => {
      if (sectionIds.has(sectionId) || event.target === placement.section || event.target.contains?.(placement.section)) {
        sectionIds.add(sectionId);
        placement.disconnect();
      }
    });
    document.querySelectorAll('modal-dialog.canvoil-size-guide').forEach(modal => {
      if (sectionIds.has(modal.dataset.sectionId)) guides.get(modal)?.disconnect();
    });
  });
})();
